import { render, staticRenderFns } from "./queryUpdate.vue?vue&type=template&id=5455ccf8&"
import script from "./queryUpdate.vue?vue&type=script&lang=js&"
export * from "./queryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports